import {BaseDomainDataSource} from "../../../infrastructure/models/base-domain-data-source";
import {FooterResponseApiModel} from "./footer.response-api-model";

export class FooterDataSource extends BaseDomainDataSource {
  apiModel: FooterResponseApiModel;

  constructor(apiModel: FooterResponseApiModel) {
    super(apiModel);

    this.description = apiModel.description;
  }
}